"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var md_1 = require("react-icons/md");
var NativeSelect = function (_a) {
    var options = _a.options, className = _a.className, value = _a.value, onChange = _a.onChange;
    var optionItems = options.map(function (_a, key) {
        var id = _a.id, name = _a.name;
        return (React.createElement("option", { value: id, key: key }, name));
    });
    return (React.createElement("div", { className: classnames_1.default(styles.nativeSelect, className) },
        React.createElement("select", { className: styles.input, value: value || '', onChange: function (e) {
                onChange(e.currentTarget.value);
            } }, optionItems),
        React.createElement(md_1.MdArrowDropDown, { className: styles.icon })));
};
exports.default = NativeSelect;
